











































import {Component, Vue} from 'vue-property-decorator';
import ExpirableDocumentDTO from "@/dto/ExpirableDocumentDTO"
import DocumentService from "@/services/DocumentService";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import RouteNames from "@/router/RouteNames";
import {namespace} from "vuex-class";
import {PERSON_ID, WORKSPACE_ID, WORKSPACE_TYPE} from "@/constants/Paths";
import {Dictionary} from "vue-router/types/router";
import {WorkspaceTypePathElement} from "@/dto/auth/Workspace";
import {ExpirableDocumentType} from "@/constants/DocumentConstants";
import {processError} from "@/utils/ComponentUtils";

const AppModule = namespace("App");

@Component(
    {
      components: {PaginationComponent}
    }
)

export default class ExpiredDocumentsTable extends Vue {

  @AppModule.Action
  private startLoading!: () => void

  @AppModule.Action
  private stopLoading!: () => void

  private pageNumber = 1

  private totalPages = 1

  private changePage(page: number): void {
    this.pageNumber = page;
    this.getExpiringDocumentPage();
  }


  private expiredDocuments: ExpirableDocumentDTO[] = []

  mounted() {
    this.getExpiringDocumentPage();
  }


  getExpiringDocumentPage() {
    this.startLoading()
    DocumentService.getExpirableDocumentPage(this.pageNumber, 20).then(
        response => {

          this.expiredDocuments = response.data.content;
          this.totalPages = response.data.totalPages;
          this.stopLoading()
        },
        error => {
          this.stopLoading();
          processError(this, error);
        }
    )
  }

  getRowColor(document: ExpirableDocumentDTO) {
    const expirationDate = new Date(document.expirationDate);
    const today = new Date();
    const nextWeek = new Date();
    nextWeek.setDate(nextWeek.getDate() + 7);

    if (expirationDate < today) {
      return 'expired-row';
    } else if (expirationDate < nextWeek) {
      return 'expiring-soon-row';
    } else {
      return '';
    }
  }

  gotoDocumentPage(document: ExpirableDocumentDTO) {
    if (document.person) {
      const params: Dictionary<string> = {}
      params[PERSON_ID] = `${document.person.id}`
      switch (document.type) {
        case ExpirableDocumentType.EAD:
        case ExpirableDocumentType.CITIZEN_PASSPORT:
        case ExpirableDocumentType.STATE_ID:
        case ExpirableDocumentType.GREEN_CARD:
          this.$router.push({name: RouteNames.PROFILE_PERSON_DOCUMENTS, params: params});
      }
    }
    if (document.company) {
      const params: Dictionary<string> = {}
      params[WORKSPACE_TYPE] = WorkspaceTypePathElement.COMPANY
      params[WORKSPACE_ID] = `${document.company.id}`
      switch (document.type) {
        case ExpirableDocumentType.BUSINESS_GENERAL_LIABILITY_INSURANCE:
          this.$router.push({ name: RouteNames.ARCHIVE_INSURANCE_GENERAL_LIABILITY, params: params });
          break;
        case ExpirableDocumentType.BUSINESS_PROFESSIONAL_LIABILITY_INSURANCE:
          this.$router.push({ name: RouteNames.ARCHIVE_INSURANCE_PROFESSIONAL_LIABILITY, params: params });
          break;
        case ExpirableDocumentType.BUSINESS_WORKERS_COMPENSATION_INSURANCE:
          this.$router.push({ name: RouteNames.ARCHIVE_INSURANCE_WORKERS_COMPENSATION, params: params });
          break;
        case ExpirableDocumentType.BUSINESS_DISABILITY_INSURANCE:
          this.$router.push({ name: RouteNames.ARCHIVE_INSURANCE_DISABILITY, params: params });
          break;
      }
    }
  }
}
